import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Validator from '../../Common/validator'
import Radium from 'radium';
import { reduxForm } from 'redux-form';
import { semanticColors } from '../../Globals/styles'
import SuggestInput from '../../Common/suggestInput'
import NumberInput from '../../Common/numberInput';
import { isStringValid } from '../../Util/stringValidator';
import $ from 'jquery';


class WizardStepOne extends Component {
  componentDidMount = () => {
    $('form').on('keyup keypress', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
  };
  componentWillReceiveProps = (nextProps) => {
    const { fields: { contacts, employees } } = nextProps;
    // eslint-disable-next-line
    if (employees.length == 0)
      employees.addField()
    else
      nextProps.fields.employees.forEach((employee, i) => {
        //Create new node if the name has a value and its the last in the list
        // eslint-disable-next-line
        if (employee.value && i == nextProps.fields.employees.length - 1)
          nextProps.fields.employees.addField()
      })
    // eslint-disable-next-line
    if (contacts.length == 0)
      contacts.addField()
    else
      nextProps.fields.contacts.forEach((contact, i) => {
        //Create new node if the name has a value and its the last in the list
        // eslint-disable-next-line
        if (contact.name.value && i == nextProps.fields.contacts.length - 1)
          nextProps.fields.contacts.addField()
      })

  };
  handleSubmitClick = () => {
    var errors = $(".has-error")
    if (errors.length) {
      $('html,body').animate({
        scrollTop: $(errors[0]).offset().top - 200
      }, 300);
    }
  };
  onArbejdsstedChange = (val) => {
    this.props.getWorkplaceSuggestions(val)
  };
  onClientChange = (val) => {
    if (!val.replace(/^\s+|\s+$/g, "")) return;
    this.props.getSuggestions(val, "client")
  };
  onEmployeeChange = (val) => {
    if (!val.replace(/^\s+|\s+$/g, "")) return;
    this.props.getSuggestions(val, "employee")
  };
  onProjectNumberBlur = (value) => {
    this.props.isProjectNumberReserved(value);
  };
  onSubmit = () => {
    if (this.props.fields.address.value)
      if (this.props.fields.address.value.id)
        this.props.getWorkplaceLocation(this.props.fields.address.value.id);

    $(this.refs.submitButton).html('<i class="fa fa-spinner fa-spin" style="font-size: 20px;"/>');

    setTimeout(() => {
      if (!this.props.projectNumberReserved)
        this.props.nextPage();
    }, 200)

  };
  render() {
    const {
      fields: {
        projectName,
      projectNumber,
      client,
      address,
      contacts,
      employees,
      mon,
      tue,
      wed,
      thu,
      fri,
      sat,
      sun
      },
      user,
      handleSubmit,
      workplaceSuggestions,
      suggestions,
      projectNumberReserved
       } = this.props;
    //is workplaceValid
    var isWorkplaceInvalid = false
    if (address.value) {
      isWorkplaceInvalid = (address.touched && !address.value.id && address.value.name.length > 0)
      if (address.initialValue)
        if (address.initialValue.name && address.initialValue.name === address.value.name)
          isWorkplaceInvalid = false
    }

    //EMPLOYEE FIELDS
    var employeeErrorMessage;
    var employeeNodes = employees.map((employee, i) => {

      //check if all employees are valid
      if (!(!employee.touched || employee.valid))
        employeeErrorMessage = employee.error;
      return <div key={i} className="row" style={styles.row}>
        <div className={employee.valid ? "col-sm-3" : "col-sm-3 error"}>
          <Validator
            isValid={!employee.touched || employee.valid}>
            <SuggestInput
              type="text"
              onQuery={this.onEmployeeChange}
              suggestions={suggestions.employee}
              placeholder="Navn"

              styleInput={styles.inputField}
              {...employee}
              onChange={(val) => { if (!val.name) { val = null } employee.onChange(val) }} />
          </Validator>
        </div>
      </div>
    });

    //CONTACT FIELDS
    var contactErrorMessage;
    var contactNodes = contacts.map((contact, i) => {

      //check if all contacts are valid
      if (!(!contact.name.touched || contact.name.valid))
        contactErrorMessage = contact.name.error;
      return <div key={i} className="row" style={styles.row}>
        <div className={contact.name.valid ? "col-sm-3" : "col-sm-3 error"}>
          <Validator
            isValid={!contact.name.touched || contact.name.valid}>
            <input
              className="form-control"
              type="text"
              placeholder="Navn"
              style={styles.inputField}
              {...contact.name} />
          </Validator>
        </div>
        <div className="col-sm-3">
          <input
            className="form-control"
            type="text"
            placeholder="Titel"
            style={styles.inputField}
            {...contact.title} />
        </div>
        <div className="col-sm-3">
          <input
            className="form-control"
            type="text"
            placeholder="Email"
            style={styles.inputField}
            {...contact.email} />
        </div>
        <div className="col-sm-2">
          <input
            className="form-control"
            type="text"
            placeholder="Telefon"
            style={styles.inputField}
            {...contact.telephone} />
        </div>
      </div>
    });
    return (
      <div>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {/*PROJECT*/}
          <div style={styles.categoryContainer}>
            <h3 style={styles.categoryHeading}>
              Sag
            </h3>
            {!(!projectNumber.touched || projectNumber.valid) || projectNumberReserved ?
              <div style={styles.errorMessage}>{projectNumberReserved ? "Sagsnummer findes allerede" : projectNumber.error}</div>
              : null}
            <div className="row" style={styles.row}>
              <div className={projectNumber.valid && !projectNumberReserved ? "col-sm-3" : "col-sm-3 error"}>
                <Validator
                  isValid={(!projectNumber.touched || projectNumber.valid) && !projectNumberReserved}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Sagsnummer"
                    style={styles.inputField}
                    {...projectNumber}
                    onChange={(evt) => {
                      let res = evt.target.value.replace(/[^0-9a-zA-Z _-]/, "");
                      evt.target.value = res;
                      projectNumber.onChange(evt);
                    }}
                    onBlur={(evt) => {
                      this.onProjectNumberBlur(evt.target.value);
                      projectNumber.onBlur(evt);
                    }}
                  />
                </Validator>
              </div>
              {!(!projectName.touched || projectName.valid) ?
                <div style={[styles.errorMessage, styles.errorMessageProjectName]}>{projectName.error}</div>
                : null}
              <div className={projectName.valid ? "col-sm-4" : "col-sm-4 error"}>
                <Validator
                  isValid={!projectName.touched || projectName.valid}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Sagsnavn"
                    style={styles.inputField}
                    {...projectName} />
                </Validator>
              </div>

            </div>
          </div>
          {/*CLIENT*/}
          <div style={styles.categoryContainer}>
            <h3 style={styles.categoryHeading}>
              Bygherre
            </h3>
            <div className="row" style={styles.row}>
              <div className="col-sm-3">
                <SuggestInput
                  className="form-control"
                  type="text"
                  onQuery={this.onClientChange}
                  suggestions={suggestions.client}
                  placeholder="Bygherre"
                  styleInput={styles.inputField}
                  {...client}
                  onChange={(val) => { if (!val.name) { val = null } client.onChange(val) }} />
              </div>
            </div>
          </div>
          {/*WORKPLACE*/}
          <div style={styles.categoryContainer}>
            <h3 style={styles.categoryHeading}>
              Arbejdssted
            </h3>
            {isWorkplaceInvalid ? <div style={[styles.errorMessage, styles.errorMessageArbejdssted]}>Ukendt adresse, kan ikke vises på kort.</div> : null}
            <div className="row" style={styles.row}>
              <div className="col-sm-5">
                <div style={styles.workplaceContainer}>
                  <SuggestInput
                    className="form-control"
                    type="text"
                    onQuery={this.onArbejdsstedChange}
                    suggestions={workplaceSuggestions}
                    placeholder="vejnavn husnr, postnummer"
                    styleInput={[styles.inputField, isWorkplaceInvalid && styles.inputFieldWarning]}
                    {...address}
                    onChange={(val) => { if (!val.name) { val = null } address.onChange(val) }} />
                </div>
              </div>
            </div>
          </div>
          {/*CONTACTS*/}
          <div style={styles.categoryContainer}>
            <h3 style={styles.categoryHeading}>
              Kontaktperson(er)
            </h3>
            {contactErrorMessage ? <div style={styles.errorMessage}>{contactErrorMessage}</div> : null}
            {contactNodes}
          </div>

          {/*EMPLOYEES*/}
          <div style={styles.categoryContainer}>
            <h3 style={styles.categoryHeading}>
              Mandskab
            </h3>
            <div className="row" style={styles.row}>
              <div className="col-sm-3">
                {user.fullname}
              </div>
            </div>
            {employeeErrorMessage ? <div style={styles.errorMessage}>{employeeErrorMessage}</div> : null}
            {employeeNodes}
          </div>
          {/*WORK RHYTHM*/}
          <div style={[styles.categoryContainer, styles.categoryContainerLast]}>
            <h3 style={styles.categoryHeading}>
              Arbejdsrytme
            </h3>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Mandag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...mon}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Tirsdag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...tue}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Onsdag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...wed}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Torsdag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...thu}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Fredag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...fri}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Lørdag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...sat}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={styles.dayHeading}>
                Søndag
              </div>
              <div style={styles.dayInputContainer}>
                <NumberInput
                  style={styles.dayInputField}
                  {...sun}
                />
              </div>
            </div>
            <div style={styles.dayContainer}>
              <div style={[styles.dayHeading, styles.dayHeadingTotal]}>
                I alt
              </div>
              <div style={styles.dayTotal}>
                {mon.value + tue.value + wed.value + thu.value + fri.value + sat.value + sun.value}
              </div>
            </div>
          </div>
          <div style={styles.submitButtonContainer}>
            <button
              ref="submitButton"
              type="submit"
              onClick={this.handleSubmitClick}
              style={styles.submitButton}
              className="btn btn-primary"
            >Næste</button>
          </div>
        </form>
      </div>
    );
  }
}

var styles = {
  categoryContainer: {
    width: '100%',
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    paddingBottom: '12px',
    paddingLeft: '12px',
    position: 'relative'
  },
  categoryContainerLast: {
    borderBottom: 'none'
  },
  categoryHeading: {
    fontSize: '18px',
    margin: '20px 0'
  },
  workplaceContainer: {
    width: '100%'
  },
  row: {
    marginBottom: '12px'
  },
  inputField: {
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    borderRadius: '2px'
  },
  inputFieldWarning: {
    border: '1px solid ' + semanticColors.warning,
    backgroundColor: semanticColors.warningLight
  },
  dayContainer: {
    width: '80px',
    display: 'inline-block',
    marginRight: '12px'
  },
  dayHeading: {
    height: '32px',
    textAlign: 'center',
    backgroundColor: semanticColors.mainBackground,
    borderRadius: '2px',
    lineHeight: '32px',
    marginBottom: '5px',
    fontWeight: '600'
  },
  dayHeadingTotal: {
    backgroundColor: 'none',
    fontWeight: '700'
  },
  dayTotal: {
    display: 'block',
    width: '100%',
    height: '34px',
    padding: '7px 12px',
    textAlign: 'center',
    fontWeight: '700'
  },
  dayInputField: {
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    textAlign: 'center',
    borderRadius: '2px'
  },
  errorMessage: {
    position: 'absolute',
    top: '20px',
    color: semanticColors.danger
  },
  errorMessageArbejdssted: {
    color: semanticColors.warning
  },
  errorMessageProjectName: {
    marginLeft: '25%',
    paddingLeft: '13px'
  },
  submitButton: {
    float: 'right',
    width: '175px',
    marginBottom: '30px',
    marginTop: '15px'
  }
}

function validateproject(data) {
  const errors = {
    contacts: [],
    employees: []
  };
  if (!isStringValid(data.projectName))
    errors.projectName = 'Skal udfyldes';
  if (!isStringValid(data.projectNumber))
    errors.projectNumber = 'Skal udfyldes';

  data.contacts.forEach((contact, index) => {
    if (!isStringValid(contact.name) && (isStringValid(contact.title) || isStringValid(contact.email) || isStringValid(contact.telephone)))
      errors.contacts[index] = { name: "Navn skal udfyldes" }
  });
  data.employees.forEach((employee, index) => {
    if (employee) {
      if (!employee.id && employee.name)
        errors.employees[index] = "Medarbejder findes ikke"
    }
  });
  return errors;
}

var w = Radium(WizardStepOne)
var WizardStepOneForm = reduxForm(
  {
    form: 'createProjectWizard',
    fields: [
      'projectName',
      'projectNumber',
      'client',
      'address',
      'contacts[].title',
      'contacts[].name',
      'contacts[].email',
      'contacts[].telephone',
      'employees[]',
      'mon',
      'tue',
      'wed',
      'thu',
      'fri',
      'sat',
      'sun'
    ],
    initialValues: {
      mon: 7.5,
      tue: 7.5,
      wed: 7.5,
      thu: 7.5,
      fri: 7,
      sat: 0,
      sun: 0
    },
    validate: validateproject,
    destroyOnUnmount: false
  }
)(w);


WizardStepOne.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  getWorkplaceSuggestions: PropTypes.func.isRequired,
  workplaceSuggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  suggestions: PropTypes.object.isRequired,
  getSuggestions: PropTypes.func.isRequired,
  isProjectNumberReserved: PropTypes.func.isRequired,
  projectNumberReserved: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired
};


export default WizardStepOneForm;



// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/wizardStepOne.jsx